// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Taglist_wrapper__H39Tu"};